<div
  class="custom_radial_chart"
  [ngClass]="{ titleBottom: titleBottom, secondStyle: secondStyle }"
>
  <div class="custom_radial_chart-title" *ngIf="title || description">
    <ng-container *ngIf="title">
      <h3 *ngIf="!progress.translate">{{ title }}</h3>
      <h3 *ngIf="progress.translate">{{ title | translate }}</h3>
    </ng-container>

    <ng-container *ngIf="description">
      <p *ngIf="!progress.translate">{{ description }}</p>
      <p *ngIf="progress.translate">{{ description | translate }}</p>
    </ng-container>
  </div>
  <div
    class="custom_radial_chart-svg"
    [ngStyle]="{
      '--stroke-color': backgroundColor,
      '--stroke-width': strokeWidth + 'px',
      '--position-offset': background_position_offset,
    }"
  >
    <svg
      class="progress-ring"
      [style.width]="svgWidth"
      [style.height]="svgHeight"
    >
      <circle
        #progressChart
        class="progress-ring__circle"
        [style.stroke]="strokeColor"
        [style.stroke-dashoffset]="strokeDashoffset"
        [attr.stroke-dasharray]="strokeDasharray"
        [style.stroke-width]="strokeWidth"
        fill="transparent"
        [attr.r]="r"
        [attr.cx]="cx"
        [attr.cy]="cy"
      />
    </svg>
    <span
      class="custom_radial_chart-svg-circle"
      [ngStyle]="{
        background: backgroundColor,
      }"
    ></span>
    <div
      class="custom_radial_chart-svg-circle-container"
      [ngStyle]="{
        transform: 'rotate(' + svgRotation + 'deg)',
      }"
    >
      <span
        class="custom_radial_chart-svg-circle"
        [ngStyle]="{
          background: backgroundColor,
        }"
      ></span>
    </div>
    <p
      class="custom_radial_chart-svg_value"
      [ngStyle]="{ color: backgroundColor, fontSize: valueFontSize }"
    >
      {{ progress.value
      }}<span *ngIf="progress?.style?.unit">{{ progress?.style?.unit }}</span>
    </p>
    <div
      class="custom_radial_chart-svg-background"
      [ngStyle]="{ '--position-offset': background_position_offset }"
    ></div>
  </div>
</div>
